import React from "react";
import ReactDOM from "react-dom";
import Posts from "./components/Posts";
import SinglePost from "./components/SinglePost";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import { Helmet } from "react-helmet";
import "./styles.css";

import { BrowserRouter as Router, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <div className="App">
        <Helmet>
          <title>CodeMind</title>
          <meta name="description" content="blog by satendra sharma" />
        </Helmet>
        <Navbar />
        <Route exact path="/" component={Posts} />
        <Route path="/post/:id" component={SinglePost} />
        <Footer />
      </div>
    </Router>
  );
}

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
